import { render, staticRenderFns } from "./FacilityDiscount.vue?vue&type=template&id=4e96433c&scoped=true"
import script from "./FacilityDiscount.vue?vue&type=script&lang=js"
export * from "./FacilityDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96433c",
  null
  
)

export default component.exports